// extracted by mini-css-extract-plugin
module.exports = {"Inspector":"Inspector_Inspector__BLs6v"};